import React from 'react';
import { Image } from 'react-bootstrap';

const Home = () => {
    return (
        <div>
        <Image className='w-100' src="https://st.redbus.in/Images/INDOFFER/FESTIVE200/Hero01.png"/>
        </div>
    );
};

export default Home;